import { client } from '../common/client';
import type { NormalizeAddressRequest, NormalizeAddressResponse } from './utils/types';

class AddressAPIClient {
  public async normalizeAddress(payload: NormalizeAddressRequest): Promise<NormalizeAddressResponse> {
    return await client.post('/address/normalize', payload).then((res) => res.data);
  }
}

export const addressAPIClient = new AddressAPIClient();
